 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1WISHINGFORMONTH from '@/components/0_chapter1wishingformonth'
 import A_CHAPTER2OLDLEATHERBOOK from '@/components/1_chapter2oldleatherbook'
 import A_CHAPTER3COLDEYEDWORLDLYEMOTION from '@/components/2_chapter3coldeyedworldlyemotion'
 import A_CHAPTER4HEARTOFMARTIALARTS from '@/components/3_chapter4heartofmartialarts'
 import A_CHAPTER5NOTTHESAME from '@/components/4_chapter5notthesame'
 import A_CHAPTER6ONEYEARDONE from '@/components/5_chapter6oneyeardone'
 import A_CHAPTER7IDOWHATIDO from '@/components/6_chapter7idowhatido'
 import A_CHAPTER8FINALLYHISHEARTHADBEENMOVED from '@/components/7_chapter8finallyhishearthadbeenmoved'
 import A_CHAPTER9PLUMANDBAMBOOHORSE from '@/components/8_chapter9plumandbamboohorse'
 import A_CHAPTER10BODYSKIN from '@/components/9_chapter10bodyskin'
 import A0_CHAPTER11OPPORTUNITYAPPROACHES from '@/components/10_chapter11opportunityapproaches'
 import A1_CHAPTER12SCHOOLMATEYOUTH from '@/components/11_chapter12schoolmateyouth'
 import A2_CHAPTER13SPECIALABILITYAWAKENING from '@/components/12_chapter13specialabilityawakening'
 import A3_CHAPTER14BENDTHEWAISTFORMONEY from '@/components/13_chapter14bendthewaistformoney'
 import A4_CHAPTER15MISUSE from '@/components/14_chapter15misuse'
 import A5_CHAPTER16SENIORAPPRENTICEBROTHERGOESOUT from '@/components/15_chapter16seniorapprenticebrothergoesout'
 import A6_CHAPTER17CALLIGRAPHY from '@/components/16_chapter17calligraphy'
 import A7_CHAPTER18PUSHONTHEDOOR from '@/components/17_chapter18pushonthedoor'
 import A8_CHAPTER19ACHIEVINGGOALS from '@/components/18_chapter19achievinggoals'
 import A9_CHAPTER20THINGSAREGOINGAWAY from '@/components/19_chapter20thingsaregoingaway'
 import A0_CHAPTER21GOABROAD from '@/components/20_chapter21goabroad'
 import A1_CHAPTER22PRICEOFDEPARTURE from '@/components/21_chapter22priceofdeparture'
 import A2_CHAPTER23BEAUTYLEADING from '@/components/22_chapter23beautyleading'
 import A3_CHAPTER24WARMTHOFJOURNEY from '@/components/23_chapter24warmthofjourney'
 import A4_CHAPTER25CINNABAR from '@/components/24_chapter25cinnabar'
 import A5_CHAPTER26STATICMOTILITY from '@/components/25_chapter26staticmotility'
 import A6_CHAPTER27GASFEELINGOUT from '@/components/26_chapter27gasfeelingout'
 import A7_CHAPTER28THREEYEARSWORK from '@/components/27_chapter28threeyearswork'
 import A8_CHAPTER29WISHFULTHINKING from '@/components/28_chapter29wishfulthinking'
 import A9_CHAPTER30ECONOMICFISSURE from '@/components/29_chapter30economicfissure'
 import A0_CHAPTER31MISUNDERSTANDING from '@/components/30_chapter31misunderstanding'
 import A1_CHAPTER32TRUEHEARTOFTHESTRONG from '@/components/31_chapter32trueheartofthestrong'
 import A2_CHAPTER33FOURTHBROTHEREMERGED from '@/components/32_chapter33fourthbrotheremerged'
 import A3_CHAPTER34NANYANGDESCENDINGHEAD from '@/components/33_chapter34nanyangdescendinghead'
 import A4_CHAPTER35HUMANSARELIKEANTS from '@/components/34_chapter35humansarelikeants'
 import A5_CHAPTER36DONOTPROVOKEANTS from '@/components/35_chapter36donotprovokeants'
 import A6_CHAPTER37AMALGAMATIONOFTWOPHASES from '@/components/36_chapter37amalgamationoftwophases'
 import A7_CHAPTER38CARDIACMOMENT from '@/components/37_chapter38cardiacmoment'
 import A8_CHAPTER39YINANDYANG from '@/components/38_chapter39yinandyang'
 import A9_CHAPTER40SYNONYM from '@/components/39_chapter40synonym'
 import A0_CHAPTER41TAOHAIPATHLESS from '@/components/40_chapter41taohaipathless'
 import A1_CHAPTER42TAOHAIPATHLESS2 from '@/components/41_chapter42taohaipathless2'
 import A2_CHAPTER43EPHEMERALHAPPINESS from '@/components/42_chapter43ephemeralhappiness'
 import A3_CHAPTER44MONEYMONEYMONEYMONEY from '@/components/43_chapter44moneymoneymoneymoney'
 import A4_CHAPTER45DOORREQUEST from '@/components/44_chapter45doorrequest'
 import A5_CHAPTER46500000YUAN from '@/components/45_chapter46500000yuan'
 import A6_CHAPTER47LEESEVIL from '@/components/46_chapter47leesevil'
 import A7_CHAPTER48LETHERBETHEONE from '@/components/47_chapter48letherbetheone'
 import A8_CHAPTER49YOUREBACK from '@/components/48_chapter49youreback'
 import A9_CHAPTER50HERSORROW from '@/components/49_chapter50hersorrow'
 import A0_CHAPTER51NAILCONIZATION from '@/components/50_chapter51nailconization'
 import A1_CHAPTER52ONENIGHT from '@/components/51_chapter52onenight'
 import A2_CHAPTER53MORNINGLANGUAGE from '@/components/52_chapter53morninglanguage'
 import A3_CHAPTER54SEVERALPLEASURES from '@/components/53_chapter54severalpleasures'
 import A4_CHAPTER55CURIOSITYHUNTINGPSYCHOLOGY from '@/components/54_chapter55curiosityhuntingpsychology'
 import A5_CHAPTER56UNRECOGNIZEDMEETING from '@/components/55_chapter56unrecognizedmeeting'
 import A6_CHAPTER57YOUNGLIEXPERIENCE from '@/components/56_chapter57youngliexperience'
 import A7_CHAPTER58NEWARRIVALINTHAILAND from '@/components/57_chapter58newarrivalinthailand'
 import A8_CHAPTER59THEREISNOAFTEREFFECT from '@/components/58_chapter59thereisnoaftereffect'
 import A9_CHAPTER60UNSPEAKABLE from '@/components/59_chapter60unspeakable'
 import A0_CHAPTER61ANACARBAZONE from '@/components/60_chapter61anacarbazone'
 import A1_CHAPTER62THEGOLDENCHICKENSTORY from '@/components/61_chapter62thegoldenchickenstory'
 import A2_CHAPTER63IVESEENAGHOST from '@/components/62_chapter63iveseenaghost'
 import A3_CHAPTER64GRAMSRELIC from '@/components/63_chapter64gramsrelic'
 import A4_CHAPTER65PLUMBLOSSOMDESTINY from '@/components/64_chapter65plumblossomdestiny'
 import A5_CHAPTER66DIVINEPOWEROFTHEVALLEYPATH from '@/components/65_chapter66divinepowerofthevalleypath'
 import A6_CHAPTER67WHOWASHEINHISPREVIOUSLIFE from '@/components/66_chapter67whowasheinhispreviouslife'
 import A7_CHAPTER68SOULSUMMONINGANDPHANTOMSUMMONING from '@/components/67_chapter68soulsummoningandphantomsummoning'
 import A8_CHAPTER69THEKILLINGART from '@/components/68_chapter69thekillingart'
 import A9_CHAPTER70THEDEVILSWILLOFMAN from '@/components/69_chapter70thedevilswillofman'
 import A0_CHAPTER71FORCEDADMISSIONS from '@/components/70_chapter71forcedadmissions'
 import A1_CHAPTER72PROPHESYINGEVIL from '@/components/71_chapter72prophesyingevil'
 import A2_CHAPTER73BLOODCORPSESISTERYUAN from '@/components/72_chapter73bloodcorpsesisteryuan'
 import A3_CHAPTER74CRYSTALPALACE from '@/components/73_chapter74crystalpalace'
 import A4_CHAPTER75LOATHSOMERICE from '@/components/74_chapter75loathsomerice'
 import A5_CHAPTER76SUDDENATTACK from '@/components/75_chapter76suddenattack'
 import A6_CHAPTER77BEATTODEATH from '@/components/76_chapter77beattodeath'
 import A7_CHAPTER78RESURRECTINGFROMDEATH from '@/components/77_chapter78resurrectingfromdeath'
 import A8_CHAPTER79YEARNINGFORPOWER from '@/components/78_chapter79yearningforpower'
 import A9_CHAPTER80SEVENTHSAINT from '@/components/79_chapter80seventhsaint'
 import A0_CHAPTER81HETEROPHOBIA from '@/components/80_chapter81heterophobia'
 import A1_CHAPTER82BOTHWERECLEARLYIDENTIFIED from '@/components/81_chapter82bothwereclearlyidentified'
 import A2_CHAPTER83SAYYOUREDEAD from '@/components/82_chapter83sayyouredead'
 import A3_CHAPTER84DECAPITATIONOIL from '@/components/83_chapter84decapitationoil'
 import A4_CHAPTER85BEFORERETURN from '@/components/84_chapter85beforereturn'
 import A5_CHAPTER86UNKNOWNSHADOW from '@/components/85_chapter86unknownshadow'
 import A6_CHAPTER87ACCIDENTALKILLING from '@/components/86_chapter87accidentalkilling'
 import A7_CHAPTER88RECOGNITIONRELATIONSHIP from '@/components/87_chapter88recognitionrelationship'
 import A8_CHAPTER89PERIODOFONEYEAR from '@/components/88_chapter89periodofoneyear'
 import A9_CHAPTER90BEWRUNGDRY from '@/components/89_chapter90bewrungdry'
 import A0_CHAPTER91GOTONANYANG from '@/components/90_chapter91gotonanyang'
 import A1_CHAPTER92GUOFAMILY from '@/components/91_chapter92guofamily'
 import A2_CHAPTER93MISSGUO from '@/components/92_chapter93missguo'
 import A3_CHAPTER94GUOFAMILY from '@/components/93_chapter94guofamily'
 import A4_CHAPTER95SPENDTHRIFT from '@/components/94_chapter95spendthrift'
 import A5_CHAPTER96LIUSYUTANG from '@/components/95_chapter96liusyutang'
 import A6_CHAPTER97CRAZYKUNGFU from '@/components/96_chapter97crazykungfu'
 import A7_CHAPTER98HERMASTERWASELDERSISTERRU from '@/components/97_chapter98hermasterwaseldersisterru'
 import A8_CHAPTER99MARTIALARTSBARRIER from '@/components/98_chapter99martialartsbarrier'
 import A9_CHAPTER100EXCHANGEBOXING from '@/components/99_chapter100exchangeboxing'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1wishingformonth",
 			"name" : "0_chapter1wishingformonth",
 			"component" : A_CHAPTER1WISHINGFORMONTH
 		},
 		{
 			"path" : "/1_chapter2oldleatherbook",
 			"name" : "1_chapter2oldleatherbook",
 			"component" : A_CHAPTER2OLDLEATHERBOOK
 		},
 		{
 			"path" : "/2_chapter3coldeyedworldlyemotion",
 			"name" : "2_chapter3coldeyedworldlyemotion",
 			"component" : A_CHAPTER3COLDEYEDWORLDLYEMOTION
 		},
 		{
 			"path" : "/3_chapter4heartofmartialarts",
 			"name" : "3_chapter4heartofmartialarts",
 			"component" : A_CHAPTER4HEARTOFMARTIALARTS
 		},
 		{
 			"path" : "/4_chapter5notthesame",
 			"name" : "4_chapter5notthesame",
 			"component" : A_CHAPTER5NOTTHESAME
 		},
 		{
 			"path" : "/5_chapter6oneyeardone",
 			"name" : "5_chapter6oneyeardone",
 			"component" : A_CHAPTER6ONEYEARDONE
 		},
 		{
 			"path" : "/6_chapter7idowhatido",
 			"name" : "6_chapter7idowhatido",
 			"component" : A_CHAPTER7IDOWHATIDO
 		},
 		{
 			"path" : "/7_chapter8finallyhishearthadbeenmoved",
 			"name" : "7_chapter8finallyhishearthadbeenmoved",
 			"component" : A_CHAPTER8FINALLYHISHEARTHADBEENMOVED
 		},
 		{
 			"path" : "/8_chapter9plumandbamboohorse",
 			"name" : "8_chapter9plumandbamboohorse",
 			"component" : A_CHAPTER9PLUMANDBAMBOOHORSE
 		},
 		{
 			"path" : "/9_chapter10bodyskin",
 			"name" : "9_chapter10bodyskin",
 			"component" : A_CHAPTER10BODYSKIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js